import { render, staticRenderFns } from "./HoldingUpsell.vue?vue&type=template&id=135d7c01&"
import script from "./HoldingUpsell.vue?vue&type=script&lang=ts&"
export * from "./HoldingUpsell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports